import React, { PureComponent } from 'react'
import { Paper, ListItem, Grid, MenuItem } from '@material-ui/core'
import { LoyaltyAccrueOptions, Appcues, EnableRewardsOptions } from '../../utils/constants'
import EditActionComponent from '../common/EditActionComponent'
import {
  EditableCheckbox,
  EditableSwitch,
  EditableSelect,
  EditableTextField,
} from '../common/EditableComponents'
import { hasAccess } from '../../utils/api'
import { connect } from 'react-redux'
import { getCompanyFeatures } from '../../actions/company'

class LoyaltyRewardsUnconnected extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      enableSpringBigCompanyFeature: false,
    }
  }

  componentDidMount() {
    this.props.dispatch(getCompanyFeatures()).then((res) => {
      const enableSpringBig = res && res.enableSpringBig && res.enableSpringBig === true
      this.setState({
        enableSpringBigCompanyFeature: enableSpringBig,
      })
    })
  }

  onChange = (key, isCheckBox) => (e) => {
    let value = isCheckBox ? e.target.checked : e.target.value
    value = key === 'enableSpringBig' ? value === EnableRewardsOptions[1].value : value

    this.props.onChange(key, value)
  }

  onSave = () => {
    this.props.onSave((response) => {
      Appcues.track('Loyalty Rewards saved')
      this.props.disableEdit()
    })
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    let options = []
    const { data = {}, editMode } = this.props

    const { enableSpringBigCompanyFeature } = this.state

    if (!enableSpringBigCompanyFeature) {
      options = EnableRewardsOptions.filter((e) => e.value !== 'SpringBig')
    } else {
      options = EnableRewardsOptions
    }

    const selectedLoyaltyOption =
      LoyaltyAccrueOptions.find((item) => item.value === data.loyaltyAccrueOpt) || {}

    const selectedEnableRewardsOption =
      options.find(
        (item) => (item.value === EnableRewardsOptions[1].value) === data.enableSpringBig,
      ) || {}

    console.log('data.enableSpringBig ', data.enableSpringBig, data)

    return (
      <div>
        <Grid container>
          <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
            {hasAccess() ? (
              <div className="pull-right margin-bottom-small">
                <EditActionComponent
                  onSave={this.onSave}
                  onCancel={this.onCancel}
                  onEdit={this.props.enableEdit}
                  editMode={editMode}
                />
              </div>
            ) : (
              <div className="pull-right margin-bottom-small"></div>
            )}
          </Grid>
        </Grid>
        <Grid container>
          <Grid className="loyaltyRewards" item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <ListItem>
                <Grid container>
                  <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold labelField">
                    Enable Rewards
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <EditableCheckbox
                      checked={data.enableLoyalty}
                      onChange={this.onChange('enableLoyalty', true)}
                      valueToRender={data.enableLoyalty ? 'Enabled' : 'Not Enabled'}
                      editMode={editMode}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid item xs={12} sm={6} md={6} lg={6}></Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} className="editField">
                    <span>Only 1 rewards system can be active at a time.</span>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid item xs={12} sm={6} md={6} lg={6}></Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin">
                    <EditableSelect
                      value={selectedEnableRewardsOption.value}
                      onChange={this.onChange('enableSpringBig')}
                      valueToRender={selectedEnableRewardsOption.label}
                      editMode={editMode}
                    >
                      {options.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item.value}>
                            {item.label}
                          </MenuItem>
                        )
                      })}
                    </EditableSelect>
                  </Grid>
                </Grid>
              </ListItem>
              {!data.enableSpringBig ? (
                <div>
                  <ListItem>
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold labelField">
                        Loyalty Accrue Option
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin">
                        <EditableSelect
                          value={data.loyaltyAccrueOpt}
                          onChange={this.onChange('loyaltyAccrueOpt')}
                          valueToRender={selectedLoyaltyOption.label}
                          editMode={editMode}
                        >
                          {LoyaltyAccrueOptions.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.value}>
                                {item.label}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold labelField">
                        Earn 1 point for X dollars
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin">
                        <EditableTextField
                          valueToRender={data.dollarToPointRatio}
                          editMode={editMode}
                          value={data.dollarToPointRatio}
                          onChange={this.onChange('dollarToPointRatio')}
                          type="number"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                </div>
              ) : (
                <div></div>
              )}
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}

const LoyaltyRewards = connect(({ dispatch, companyReducer }) => ({ dispatch, companyReducer }))(
  LoyaltyRewardsUnconnected,
)

export default LoyaltyRewards



// WEBPACK FOOTER //
// ./src/components/LoyaltyRewards/index.js